import React from 'react';
export default function notFoundPage(){
    return (<div>404 Not Found Page</div>);
}